import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    resourcePath: null,
    workTimestamp: 0,
    //
    nowLockKey: null,     // null:pubモード or 取得中 / "":取得失敗 / キー文字列:取得完了
    nowUserID: null,
    //
    documentAreaWidth: 100,
    documentAreaHeight: 100,
    documentAreaWatcher: performance.now(),
    //
    appReferrer:"",
    //
    fontActive: false,
    restFontLoaded: false,
    //
    notResigingDoc: true,
  },
  mutations: {
    setResourcePath(state, resourcePath) {
      state.resourcePath = resourcePath
    },
    setWorkTimestamp(state, workTimestamp) {
      state.workTimestamp = workTimestamp
    },
    setNowLockKey(state, nowLockKey) {
      state.nowLockKey = nowLockKey
    },
    setNowUserID(state, nowUserID) {
      state.nowUserID = nowUserID
    },
    setDocumentArea(state,el) {
      if ((state.documentAreaWidth !== el.clientWidth) || (state.documentAreaHeight !== el.clientHeight)) {
        state.documentAreaWidth = el.clientWidth
        state.documentAreaHeight = el.clientHeight
        state.documentAreaWatcher = performance.now()
      }
    },
    setAppReferrer(state,appReferrer) {
      state.appReferrer = appReferrer
    },
    setFontActive(state,fontActive) {
      console.log('setFontActive')
      state.fontActive = fontActive
    },
    setRestFontLoaded(state,restFontLoaded) {
      state.restFontLoaded = restFontLoaded
    },
    setNotResigingDoc(state,notResigingDoc) {
      state.notResigingDoc = notResigingDoc
    }
  },
  getters: {
  },
})

// export function stringWorkID(wid) {
//   return 'work-' + wid
// }
